module.exports = __webpack_public_path__ + "img/experience_right_arrow.93c00ba9.png";